import { useState } from 'react';
import { Pressable, ScrollView, StyleSheet, Text, View } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import AuthInput from '../components/AuthInput';
import colors from '../theme';
import { RootStackParamList } from '../navigation/RootNavigator';

type Props = NativeStackScreenProps<RootStackParamList, 'CreatePassword'>;

export default function CreatePasswordScreen({ navigation }: Props) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View style={styles.header}>
        <Pressable onPress={() => navigation.goBack()} style={styles.backButton}>
          <Text style={styles.backButtonText}>{'<'}</Text>
        </Pressable>
        <Text style={styles.heading}>Tạo mật khẩu mới</Text>
      </View>
      <View style={styles.authBox}>
        <AuthInput label="Mật khẩu mới" placeholder="Nhập mật khẩu mới" secureTextEntry value={password} onChangeText={setPassword} />
        <AuthInput label="Xác nhận mật khẩu" placeholder="Nhập lại mật khẩu" secureTextEntry value={confirmPassword} onChangeText={setConfirmPassword} />
        <Pressable style={styles.mainButton} onPress={() => navigation.navigate('Login')}>
          <Text style={styles.mainButtonText}>Đặt lại mật khẩu</Text>
        </Pressable>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: colors.background,
    paddingHorizontal: 24,
    paddingTop: 44,
  },
  header: {
    marginBottom: 28,
  },
  backButton: {
    width: 36,
    height: 36,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.border,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  backButtonText: {
    color: colors.textPrimary,
    fontSize: 18,
  },
  heading: {
    color: colors.textPrimary,
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 28,
  },
  authBox: {
    padding: 0,
    borderRadius: 0,
    backgroundColor: colors.panel,
  },
  mainButton: {
    backgroundColor: colors.button,
    borderRadius: 5,
    paddingVertical: 12,
    alignItems: 'center',
    marginTop: 24,
  },
  mainButtonText: {
    color: colors.buttonText,
    fontWeight: '700',
    fontSize: 14,
  },
});
